/**
 * Whether the thread list renders as the fully-virtual sparse list.
 *
 * The virtual list is addressed by OFFSET and paints skeleton rows for slots it has not fetched,
 * healing them as the window reports a total. That only works for the patient Messages scope,
 * which is windowed. The scoped lists — internal Chats and private contact chats — are fetched
 * complete in one request and have no window at all, so the virtual list would show placeholder
 * rows that never resolve.
 *
 * That is not hypothetical: this rule tested `!isInternalScope`, so the Private pane fell into the
 * virtual list with its window disabled and sat on skeletons forever.
 */
export function isVirtualThreadListActive({
  isScopedList,
  threadSearchActive,
  pinnedLensActive,
  threadLens,
  waGroupsLensActive,
} = {}) {
  if (isScopedList) return false;
  if (threadSearchActive) return false;
  if (pinnedLensActive) return false;
  return threadLens === 'all' || Boolean(waGroupsLensActive);
}
